<template>
<div class="chapter">
<div class="inner_page">
<p class="chapter-h"><span>What to Do on New Year’s Eve — II</span></p>
<p class="normal"><span class="dropcap">O</span><span class="smallcaps">KAY</span>. You’re sitting home alone on New Year’s Eve with auld lang syne on your hands. What do you do?</p>
<p class="indentb">1. Get out your Scottish dictionary and look up <i>auld lang syne</i>. You could dig around for hours without finding your Scottish dictionary. Get out your Scotch.</p>
<p class="indentb">2. Wear a lampshade on your head. I have seen people do almost everything at a party: fall down, get naked, fight, start fires, climb out of windows, and put big wet slices of warm roast beef down each other’s shirts. But I have never seen anybody put a lampshade on his or her head.</p>
<p class="indent">Try it, and you’ll see why. A lampshade has prongs that don’t fit the human head (might fit a cat’s, but a cat would hate it), and there are dead moths in there. Stuck to the sides. But not stuck very securely. You could breathe one into your nose.</p>
<p class="indentb">3. Call up friends. One problem with this is, they may be having a party that they didn’t invite you to. I don’t know why; they just didn’t. Even if they live several hundred miles away, which would explain (maybe) why you weren’t invited, they probably won’t answer their phone themselves. Someone whose voice you don’t recognize, and probably wouldn’t recognize even if it weren’t thickened by debauchery, will answer and say:</p>
<p class="indent">“HARPY NOYERS!”</p>
<p class="indent">“Hello,” you’ll say. “I’m a friend of Griff and Betty’s —”</p>
<p class="indent">“HOOPY NOO-WAH!”</p>
<p class="indent">“Is Griff or Betty —”</p>
<p class="indent">“HOPPAH NAW REE!”</p>
<p class="indent">There will be a sound like people throwing roast beef in the background and you will hear the phone hit the floor. Eat your heart out.</p>
<p class="indenta">4. Get yourself organized for the months ahead. There are twelve of them. I won’t list them here. You could take out twelve slips of paper, write the name of a different month on each one, and set them out neatly, in chronological order (I mean the order in which the months come during the year, not the order in which you wrote them on the slips, though it is a good idea to write them on the slips in the same order in which they come during the year, because otherwise you could forget March), on a desk or tabletop. Or the floor will do. Especially if you have fallen down.</p>
<p class="indent">Now. Take more slips of paper, a lot of them, and write on each one something that you intend to get done:</p>
<table>
<tbody><tr>
<td class="table-4"><span class="big1">•</span></td>
<td class="table-3">Take up organ.</td>
</tr>
<tr>
<td class="table-4"><span class="big1">•</span></td>
<td class="table-3">Oil reels.</td>
</tr>
<tr>
<td class="table-4"><span class="big1">•</span></td>
<td class="table-3">Obedience classes — Mitzi.</td>
</tr>
<tr>
<td class="table-4"><span class="big1">•</span></td>
<td class="table-3">Winterize gazebo.</td>
</tr>
<tr>
<td class="table-4"><span class="big1">•</span></td>
<td class="table-3">Get racquetball racquet. (In your wording, you want to be terse and businesslike. Isn’t there something redundant about “racquetball racquet”? You wouldn’t say “football foot.” “Tennis tennis-ball.” And isn’t that a pretty la-di-da spelling —“racquet”? As in “leather jacquet,” or “yacquety-yacque.”)</td>
</tr>
<tr>
<td class="table-4"><span class="big1">•</span></td>
<td class="table-3">Europe. (But you don’t want to be so terse in your wording that, when the month to get this thing done rolls around, you won’t remember what it was you were going to do. <i>Visit</i> Europe? Reassess Europe’s role in the world community today? Or does that say “Elope”? Use good handwriting.)</td>
</tr>
<tr>
<td class="table-4"><span class="big1">•</span></td>
<td class="table-3">Look into umbrella coverage.</td>
</tr>
<tr>
<td class="table-4"><span class="big1">•</span></td>
<td class="table-3">Get things straight with the Seebohms.</td>
</tr>
<tr>
<td class="table-4"><span class="big1">•</span></td>
<td class="table-3">Learn cook Indian.</td>
</tr>
<tr>
<td class="table-4"><span class="big1">•</span></td>
<td class="table-3">Add inch to chest.</td>
</tr>
</tbody></table>
<p class="indent">And so on. Now sort these slips of paper into twelve piles of things you are going to get done each month.</p>
<p class="indent">But are you going to get them done? Probably not. There is not much point in embarking upon the new year by trying to fool yourself. And failing.</p>
<p class="indentb">5. Come up with this great idea for a screenplay about this guy who doesn’t have anything to do on New Year’s Eve or anybody to do it with, right? And he’s all alone, see, so he’s sitting there thinking [<i>voiceover</i>]: “Hey, this would be a great idea for a screenplay: a guy who’s all alone on New Year’s Eve trying to think of an idea for a screenplay, or trying to think of something to do, I mean, or somebody to do it with, so he …”</p>
<p class="indentb">6. Turn over a new leaf. This is something anybody could stand to do. I don’t care if you are a prominent religious leader or the world’s greatest living cellist. It wouldn’t hurt you to turn over a new leaf. But you need to be in a dynamic mood to turn over a new leaf, unless it is a tiny leaf — like, “Okay! From this day forward I will never again clip my fingernails except over a receptacle of some kind!” And if you were in a dynamic mood you wouldn’t be home alone on New Year’s Eve.</p>
<p class="indent">Furthermore: I, for example, am forty-two years old and I have never turned over a new leaf. Not on purpose. It’s like wearing a lampshade on your head. Trying to do such a classic thing makes you self-conscious. You wonder, “Is this for real?” When something is classic, you can never think of an example of how it’s done.</p>
<p class="indent">Maybe in the Greek myths. But you may not be able to put your hand on any Greek myths. I don’t think you want to start looking for them on New Year’s Eve, after you’ve already been through the whole house looking for a Scottish dictionary.</p>
<p class="indent">What if you did find, say, <i>The Iliad?</i> The Trojan Wars don’t provide much of a model for a person sitting home alone. Unless you are the type of guy who gets up and goes out and kidnaps someone named Helen. If you are, you ought to turn over a new leaf.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter21.vue?2a0c9e18